export default __webpack_public_path__ + "static/media/paper.0f966f37.svg";